<template>
  <v-row
    no-gutters
    class="Main"
  >
    <v-container v-if="!loaded">
      <v-layout
        fill-height
        align-center
        justify-center>
        <v-flex xs12><dashboard-loader /></v-flex>
      </v-layout>
    </v-container>
    <v-col
      v-else
      :class="isEmbedded ? 'pa-0 mt-5' : 'pa-0'">
      <v-container :class="{'Clock' : !booked}">
        <v-col
          v-if="!isEmbedded"
          md="10"
          sm="12"
          class="offset-md-1">
          <v-card
            v-if="loaded"
            v-show="loaded && !slotStart && !booked"
            class="elevation-0">

            <!-- Title if Default Theme-->
            <v-col
              cols="12"
              sm="12">

              <v-col
                :class="!isEmbedded ? 'py-0' : 'pa-1'"
                cols="12">
                <h1
                  :class="!isEmbedded ? 'display-1 black--text text-center font-weight-medium mb-1' : 'black--text text-center font-weight-medium mb-0'">
                  {{ selectedMeetingType.meetingTitle }}
                </h1>
                <div
                  :class="!isEmbedded ? 'body-1 grey--text text--darken-3 my-4' : 'body-2 grey--text darken-3'"
                  cols="12">
                  <span
                    :class="selectedMeetingType.description && selectedMeetingType.description.length > 140 ? 'text-left' : 'text-center'"
                    class="d-block MeetingLandingPage__description-span">{{ selectedMeetingType.description }}</span>
                </div>
              </v-col>

            </v-col>
            <v-row
              no-gutters
              wrap
              d-inline-flex
              class="MeetingLandingPage border--radius-box"
            >

              <v-col
                sm="12"
                cols="12">
                <!-- Meeting Header Info if Enterprise / Growth Plan -->
                <meeting-header-info
                  :location="commonLocation"
                  :duration="selectedMeetingType.duration"
                  :host-picture="selectedMeetingType.pictureUrl"
                  :host-name="fullName(selectedMeetingType.firstName, selectedMeetingType.lastName)"
                  :is-embedded="isEmbedded"/>
              </v-col>

              <v-col
                cols="12"
                sm="12"
              >
                <v-divider/>
                <v-card-text :class="!selectedMeetingType.whiteLabel ? 'MeetingLandingPage__slotList pa-0' : 'pa-0 MeetingLandingPage__slotList-noFooter pa-0'">
                  <!-- Slots List -->
                  <slot-list
                    @slotSelected="goToForm"/>
                </v-card-text>
              </v-col>
            </v-row>
            <!-- Footer Powered By -->
            <powered-by
              :display-text="!selectedMeetingType.whiteLabel"
              class="PoweredBy" />
          </v-card>
          <v-card
            v-if="loaded && slotStart && !booked"
            class="elevation-0">
            <v-card-text class="pa-0">
              <!-- Slot Validation Form -->
              <validation-form
                :start-timestamp="slotStart"
                :end-timestamp="slotEnd"
                :email="inviteeEmail"
                :location="commonLocation"
                @cancel="displayAllSlots"
                @booked="meetingBooked"/>
            </v-card-text>
            <!-- Footer Powered By -->
            <powered-by
              :display-text="!selectedMeetingType.whiteLabel"
              class="PoweredBy"/>
          </v-card>
          <v-card
            v-if="loaded && booked"
            flat>
            <v-card-text class="pa-0">
              <booked :white-label="selectedMeetingType.whiteLabel"/>
            </v-card-text>
            <powered-by
              :display-text="!selectedMeetingType.whiteLabel"
              class="PoweredBy"/>
          </v-card>
        </v-col>
        <!-- MINIMIFIED VERSION -->
        <v-row
          v-else-if="isEmbedded && loaded"
          v-show="loaded && !slotStart && !booked"
          no-gutters
          wrap
          d-inline-flex
        >
          <!-- Title | description -->
          <v-col
            cols="12"
            sm="12"
            class="px-1 mb-1">

            <h1
              class="headline black--text text-center font-weight-medium">
              {{ selectedMeetingType.meetingTitle }}
            </h1>
            <v-layout justify-center><v-btn
              v-if="selectedMeetingType.description && selectedMeetingType.description.length > 0"
              small
              text
              rounded
              class="text-none"
              @click="viewMeetingDescription = !viewMeetingDescription">{{ !viewMeetingDescription ? $t('booked.viewDescription') : $t('booked.hideDescription') }}</v-btn>
            </v-layout>
            <div
              v-show="viewMeetingDescription"
              class="body-2 mx-3 mt-3 grey--text darken-3"
              cols="12">
              {{ selectedMeetingType.description }}</div>

          </v-col>
          <v-row
            no-gutters>
            <v-col
              sm="12"
              cols="12"
              class="blue lighten-5 mt-2 pb-2">
              <meeting-header-info
                :location="commonLocation"
                :duration="selectedMeetingType.duration"
                :host-picture="selectedMeetingType.pictureUrl"
                :host-name="fullName(selectedMeetingType.firstName, selectedMeetingType.lastName)"
                :is-embedded="isEmbedded"/>
            </v-col>

            <v-col
              cols="12"
              md="10"
              sm="12"
              class="offset-md-1">
              <v-card-text :class="!selectedMeetingType.whiteLabel ? 'MeetingLandingPage__slotList pa-0' : 'pa-0 MeetingLandingPage__slotList-noFooter pa-0'">

                <!-- Slots List -->
                <slot-list
                  :is-embedded="isEmbedded"
                  @slotSelected="goToForm"/>
              </v-card-text>
            </v-col>
          </v-row>

          <!-- Footer Powered By -->
          <v-col
            cols="12">
            <powered-by
              :display-text="!selectedMeetingType.whiteLabel"
              class="PoweredBy__Embedded"/>
          </v-col>
        </v-row>
        <v-card
          v-if="isEmbedded && loaded"
          v-show="loaded && slotStart && !booked"
          flat
          tile
          class="elevation-0"
        >
          <v-card-text class="pa-0">
            <!-- Slot Validation Form -->
            <validation-form
              :start-timestamp="slotStart"
              :end-timestamp="slotEnd"
              :email="inviteeEmail"
              :location="commonLocation"
              :is-embedded="isEmbedded"
              @cancel="displayAllSlots"
              @booked="meetingBooked"/>
          </v-card-text>
          <!-- Footer Powered By -->
          <powered-by
            :display-text="!selectedMeetingType.whiteLabel"
            class="PoweredBy__Embedded"/>
        </v-card>
        <v-card
          v-if="isEmbedded && loaded && booked"
          flat>
          <v-card-text class="pa-0">
            <booked
              :white-label="selectedMeetingType.whiteLabel"
              :is-embedded="isEmbedded"/>
          </v-card-text>
          <powered-by
            :display-text="!selectedMeetingType.whiteLabel"
            class="PoweredBy__Embedded"/>
        </v-card>
        <v-snackbar
          v-if="loaded && !slotStart"
          v-model="snackbar"
          :timeout="10000"
          left>
          {{ $t('snackBar.homepage') }}
        </v-snackbar>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { userMixin, localeMixin } from '../mixins'
import { mapGetters } from 'vuex'
import Booked from './Booked.vue'
import DashboardLoader from './Loader.vue'
import SlotList from './SlotList.vue'
import PoweredBy from './PoweredBy.vue'
import ValidationForm from './ValidationForm.vue'
import MeetingHeaderInfo from './MeetingHeaderInfo.vue'
import _ from 'lodash'

export default {
  components: {
    Booked,
    DashboardLoader,
    PoweredBy,
    SlotList,
    ValidationForm,
    MeetingHeaderInfo
  },
  mixins: [userMixin, localeMixin],
  data () {
    return {
      booked: false,
      inviteeEmail: '',
      isEmbedded: null,
      loaded: false,
      slotStart: '',
      slotEnd: '',
      snackbar: true,
      viewMeetingDescription: false,
      windowWidth: window.innerWidth
    }
  },
  computed: {
    ...mapGetters('meetings', [
      'selectedMeetingType',
      'meetingCalendars',
      'meetingSlots'
    ]),
    commonLocation () {
      const uniqueLocation = _.uniqBy(this.meetingCalendars, 'location')
      if (uniqueLocation.length === 1) {
        if (uniqueLocation[0].createHangout) {
          return this.$t('home.googleMeet')
        } else if (uniqueLocation[0].integration === 'zoom' || uniqueLocation[0].location.includes('zoom.us/j')) {
          return this.$t('home.zoom')
        } else {
          return uniqueLocation[0].location
        }
      }
      return this.$t('home.toBeDefined')
    }
  },
  watch: {
    windowWidth (newHeight, oldHeight) {
      this.isEmbedded = newHeight < 500 ? '1' : null
    }
  },

  async mounted () {
    this.$router.push({ name: 'home' })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateScreenSize)
  },
  methods: {
    updateScreenSize (newWidth) {
      this.windowWidth = newWidth
    },
    displayAllSlots () {
      this.slotStart = ''
      this.slotEnd = ''
    },
    goToForm (slot) {
      this.slotStart = slot.startTimestamp.toString()
      this.slotEnd = slot.endTimestamp.toString()
    },
    meetingBooked () {
      this.$router.push({
        name: 'meeting',
        params: {
          prefixMeetingUrl: this.$route.params.prefixMeetingUrl,
          meetingTypeUrl: this.$route.params.meetingTypeUrl
        },
        query: {
          booked: true
        }
      }
      )
      this.booked = true
    }
  }
}
</script>
<style lang="scss">
.MeetingLandingPage {
  border :2px solid #e5e5e5;
  &__slotList {
    max-height: 54vh;
    overflow-y: scroll;
    @media screen and (max-width: $screen-xs) {
      max-height: 66vh ;
    }
    &-noFooter {
      max-height: 63vh !important;
      overflow-y: scroll;
    }
  }
  &__description-span {
    white-space: pre-wrap;
  }
  .PoweredBy {
    max-height: 10vh;
  }

}
.PoweredBy {
  &__Embedded {
    max-height: none !important;
  }
}
</style>
